import { FieldSchema } from './tableUtils'

export function isRasterBlockField(field: FieldSchema): boolean {
  return field.type.toLocaleLowerCase() === 'number' && field.name.toLocaleLowerCase() === 'block'
}
